import React  from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import BookingConfirmationForm from '../forms/BookingConfirmationForm';
import * as homeActions from '../actions/homeActions';
import EditBookingTimeForm from '../forms/EditBookingTimeForm';
import AccountDetailsForm from '../forms/AccountDetailsForm';
// import { Field, reduxForm, initialize, formValueSelector } from 'redux-form';
import Hero from '../components/Hero';
import Steps from '../components/Steps';

import UserLoginForm from '../forms/UserLoginForm';
import { userActions } from '../actions/userActions';
import AdditionalServiceForm from '../forms/AdditionalServiceForm';
import ReceiptDetailForm from '../forms/ReceiptDetailForm';
import * as pricingActions from '../actions/pricingActions';
import * as paymentActions from '../actions/paymentActions';
import EditSpecialDealDetailForm from '../forms/EditSpecialDealDetailForm';
import PaymentDetailForm from '../forms/PaymentDetailForm';

// import objectAssign from 'object-assign';
// import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import * as vehicleActions from '../actions/vehicleActions';
import AddVehicleForm from '../forms/AddVehicleForm';
import AddVehicleModalForm from '../forms/AddVehicleModalForm';
import EuroCarPark from '../../assets/images/eurocarpark.png';
// import PowerByEasytrip from '../../assets/images/power-et-w.png';

import getPortalLocData from '../config/loc';
import { toast } from 'react-toastify';


export class PayAndConfirmPage extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            modalChangeTime: false,
            modalLogin: false,
            modalDealDeails: false,
            submitting: false,
            modalVehicleDetails: false
            
        };
        this.scrollRefOut = React.createRef();
        this.scrollRef = React.createRef();
        this.toggle = this.toggle.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
    }
    
    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
      }
    
      componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
      }
    
      handleScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollRefTop = this.scrollRefOut.current.getBoundingClientRect().top + window.pageYOffset;
        let amountOfPx = 0;

        if (scrollTop  > scrollRefTop ) {
            amountOfPx = scrollTop - scrollRefTop;
        } else {
            amountOfPx = 0; }

        this.scrollRef.current.style.top = `${amountOfPx}px`;
      }
    


    toggle(property) {
        let newState = {};
        newState[property] = !this.state[property];
        this.setState(newState);
    }
    set(property, set) {
        let newState = {};
        newState[property] = set;
        this.setState(newState);
    }





    handleOptionalService=(props,param)=>{
        props.input.onChange(param);
        let{ selectedOffering,selectedOptionalServices}=this.props.locationDetail;
        let service=[...selectedOptionalServices];
        let findService=service.filter(s=>s.id==props.input.name);
        if(findService.length > 0){
            service=service.filter(s=>s.id!=props.input.name);
        } else {
            let selected=selectedOffering.ancillaryServices.filter(s=>s.id==props.input.name)[0];

            service.push(selected);
        }

        this.props.homeActions.selectedOptionalService(service).then(()=>{
            this.handlerOptionalServicePriceChange();
        });
    }

    handlerOptionalServicePriceChange(){
        let{ selectedOptionalServices}=this.props.locationDetail;
        let model = {...this.props.pricing.pricingModel};
        model.breakdown=model.breakdown.filter(s => s.description == 'SubTotal');
        selectedOptionalServices.map((item,index)=>{
            model.breakdown.push({
                tariffPrincingId:item.id,
                amount:item.grossAmount,
                vatAmount:item.vatAmount,
                description:item.name,
                baseRate:item.grossAmount,
                unitsCount:1
            });

        });
        model.totalAmount=model.breakdown.map(datum => datum.amount).reduce((a, b) => a + b);
        model.totalVAT=model.breakdown.map(datum => datum.vatAmount).reduce((a, b) => a + b);
        this.props.pricingActions.calculateAdditionalService(model);
      }

    handleConfirm(){
        this.set("submitting", true);
        
        if(this.props.authentication.loggedIn){
            this.props.paymentActions.savePaymentDetails(`${this.props.accountDetail.firstName} ${this.props.accountDetail.lastName}`)
                .then((res)=> {
                    if (!res) {
                        this.handleBooking();
                    } else {
                        this.set("submitting", false);
                        console.error(res.error);
                    }
                })
                .catch((err)=> {
                    this.set("submitting", false);
                    console.error("savePaymentDetails, ", err);
                });
        } else {
            this.props.userActions.createUserAndGetUserDetail(this.props.accountDetail)
                .then(()=>{
                    this.props.paymentActions.savePaymentDetails(`${this.props.accountDetail.firstName} ${this.props.accountDetail.lastName}`)
                        .then(()=>{
                            this.handleBooking();
                        })
                        .catch((error)=>{
                            console.error("savePaymentDetails, ", error);
                            this.set("submitting", false);
                            // this.handleBooking();
                        });
                    })
                .catch((error)=>{
                    console.error("createUserAndGetUserDetail, ", error);
                    this.set("submitting", false);
                });
        }
    }

    handleBooking(){
        let selectedOffering = this.props.locationDetail.selectedOffering;

        // true if using the set prices, false if using the custom time
        let defaultPricingModel = Object.keys(this.props.pricing.defaultPricingModel).length > 0;
        let m = (defaultPricingModel ? this.props.pricing.defaultPricingModel : this.props.pricing.dealPricingModel);

        let book = {
            offerId: selectedOffering.id,
            vehicleRegistration: this.props.accountDetail.vehiclePlate,

            grossAmount: (defaultPricingModel ?  m.totalAmount : selectedOffering.pricing.grossAmount),
            vatAmount: (defaultPricingModel ?  m.totalVAT : selectedOffering.pricing.vatAmount),

            startDate: (defaultPricingModel ?  m.breakdown[0].startTime : this.props.locationDetail.startDate),
            endDate: (defaultPricingModel ?  m.breakdown[0].endTime : this.props.locationDetail.untilDate),
        };

        this.props.homeActions.createBooking(book).then((response)=>{
            if(response.isSuccessful){
                this.props.history.push("/Confirmation");
                window.scrollTo(0, 0);
            }
            
            this.set("submitting", false);
        });
    }


    isValid(){
        let {
            firstName,
            lastName,
            email,
            phone,
            vehiclePlate,
            password,
            tcAccepted
        } = this.props.accountDetail;
        const validateEmail = (email) => {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        }; 

        const validatePhone = (phone) => {
            const phoneRegex = /^[+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{1,4}[-\s\.]?[0-9]{1,4}[-\s\.]?[0-9]{1,9}$/;
            return phoneRegex.test(phone);
        };


        let validate = (
            firstName != '' && 
            lastName != '' && 
            email    != '' && 
            validateEmail(email) &&
            phone != '' && 
            validatePhone(phone) &&
            vehiclePlate != '' && 
            tcAccepted
            );



        let validateLoggedIn = (
            firstName != '' && 
            lastName != '' && 
            email    != '' && 
            validateEmail(email) &&
            phone != '' && 
            validatePhone(phone) &&
            vehiclePlate != '' 
            );
            

       if(this.props.authentication.loggedIn ){
            let oldPayment = (
                validateLoggedIn && 
                this.props.paymentDetail.validated);

                console.log('oldPayment, ', oldPayment);
                console.log('this.props.paymentDetail.validated, ', this.props.paymentDetail.validated);
            
            let newPayment = (
                validateLoggedIn && 
                this.props.paymentDetail.cardNumber != '' && 
                this.props.paymentDetail.expiryDate && 
                this.props.paymentDetail.cvc);
                console.log('newPayment, ', newPayment);

            
            let sepa = (
                validateLoggedIn && 
                this.props.paymentDetail.data.paymentType === 'SEPA');
                console.log('sepa, ', sepa);
                console.log('this.props.paymentDetail.data.paymentType, ', this.props.paymentDetail.data.paymentType);
            

                console.log('(oldPayment) || (newPayment) || (sepa), ', (oldPayment) || (newPayment) || (sepa));
            return (oldPayment) || (newPayment) || (sepa);
        } 

        return (
            validate && 
            password != '' && 
            this.props.paymentDetail.cardNumber != '' && 
            this.props.paymentDetail.expiryDate && 
            this.props.paymentDetail.cvc);
    }

    handleSpecialDealSubmit=()=>{
        this.toggle("modalDealDeails");
      }
      handleChangeCardNumber(cardNumber){
          this.props.pricingActions.UpdateCardNumber(cardNumber);
      }
      handleChangeExpiryDate(expiryDate){
        this.props.pricingActions.UpdateExpiryDate(expiryDate);
      }
      handleChangeCVC(cvc){
        this.props.pricingActions.UpdateCVC(cvc);
      }

    addVehicle = (values) => {
        console.log(' !! ! ! values, ', values);
        let self = this;
      
          this.props.vehicleActions.addVehicle(values);
          this.props.homeActions.resetForm("addVehicleModal", {
            isFindingVehicle: false,
            attemptedFind: false,
            vehicleReg: "",
            make: "",
            model: "",
            licensePlate: "",
          });
          this.toggle("modalVehicleDetails");
    }

      




    render(){
        let { 
            isFetching, 
            startDate, 
            selectedLocationId, 
            selectedOffering, 
            untilDate, 
            selectedLocation 
        } = this.props.locationDetail;
        
        let { loggingIn, loggedIn } = this.props.authentication;
        let { validated } = this.props.paymentDetail;
        let { pricingModel } = this.props.pricing;

        let steps = ['Pick Dates', 'Enter your details', 'Receive confirmation'];


        return (

            <div>
                { getPortalLocData().name === "airport" &&
                    <Hero 
                        title="Airport Parking"
                        img={"/images/" + getPortalLocData().name + "/header-image.jpg"} />
                }

                <div className='limit-content main-container'>

            
                    <div className="account-details col-12">
                        <Steps 
                            step={2}
                            steps={steps} />
                
                        <h1>
                            <i className="fa fa-ticket fa-lg"></i> Pay &amp; Confirm
                        </h1>
                            <div className="row">
                                <div className="col-md-7">
                                    <div className="row">
                                        <div className="col-md-12 mb-4">
                                            <AccountDetailsForm 
                                                handleLogin={()=>this.toggle("modalLogin")}
                                                isLoading={this.props.accountDetail.isFetching}
                                                loggedIn={loggedIn}
                                                firstName={this.props.accountDetail.firstName}
                                                lastName={this.props.accountDetail.lastName}
                                                email={this.props.accountDetail.email}
                                                tcAccepted={this.props.accountDetail.tcAccepted}
                                                />
                                        </div>

                                        <div className="col-md-12 mb-4">
                                            <AddVehicleForm 
                                                addVehicle={()=>this.toggle("modalVehicleDetails")}
                                                findVehicle={(reg) => this.props.vehicleActions.checkVehicleReg(reg)}
                                                />
                                        </div>
                                        {
                                            selectedOffering && selectedOffering.ancillaryServices.length > 0 ?
                                            (<div className="col-md-12 mb-4">
                                            <AdditionalServiceForm ancillaryServices={[...selectedOffering.ancillaryServices]} 
                                                                    isLoading={isFetching}
                                                                    handleOptionalServiceChange={this.handleOptionalService}
                                            />
        
                                            </div>):null
                                        }
                                    
                                        <div className="col-md-12 mb-4">
                                            <PaymentDetailForm
                                                isFetching={isFetching}
                                                loggingIn={loggingIn} 
                                                isSubmitting={this.state.submitting}
                                                handleChangeCardNumber={(evt)=>this.handleChangeCardNumber(evt.target.value)}
                                                handleChangeExpiryDate={(evt)=>this.handleChangeExpiryDate(evt.target.value)}
                                                handleChangeCVC={(evt)=>this.handleChangeCVC(evt.target.value)}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-5 px-md-3 easytrip-card__out  mt-n4" ref={this.scrollRefOut}>
                                    <div className="easytrip-card position-static position-md-relative mt-4" ref={this.scrollRef}>
                                        <div className="easytrip-card__drawer" >
                                            <div id="receipt_detail" className="col-12 col-xs-12 receipt_detail px-3 pt-2">
                                                <h5 className="one-line-truncate bold">
                                                    {selectedLocation.location.name}
                                                </h5>
                                                <div className="text-right mt-4">
                                                    <p className="receipt_detail__total">
                                                        {`€${pricingModel.totalAmount.toFixed(2)}`}
                                                    </p>
                                                </div>
                                                <div className="text-right">
                                                    <p className="receipt_detail__vat">
                                                        Total payment includes VAT of {`€${pricingModel.totalVAT.toFixed(2)}`}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            {getPortalLocData().name === 'conventionCentre' &&
                                                <div className="eurocarparks-head">
                                                    <img alt="Euro Car Parks" src={EuroCarPark} />
                                                </div>
                                            }
                                            
                                            <ReceiptDetailForm selectedLocation={selectedLocation.location} isLoading={isFetching}/>

                                            <div className={"px-3 no-click " + (this.state.submitting ? "no-click__active " : "")}>
                                                <BookingConfirmationForm 
                                                    pricingModel={pricingModel} 
                                                    offeringType={this.props.locationDetail.selectedOffering.type} 
                                                    handleDateChange={()=>this.toggle(this.props.locationDetail.selectedOffering.type==0? "modalChangeTime":"modalDealDeails")}/>
                                            </div>

                                            <div id="receipt_detail" className="col-12 col-xs-12 receipt_detail" >
                                                <div className="text-right mt-4">
                                                    <p className="receipt_detail__total">
                                                        {`€${pricingModel.totalAmount.toFixed(2)}`}
                                                    </p>
                                                </div>
                                                <div className="text-right">
                                                    <p className="receipt_detail__vat">
                                                        Total payment includes VAT of {`€${pricingModel.totalVAT.toFixed(2)}`}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="col easytrip-card__foot">
                                                <div className="text-right">
                                                    <button 
                                                        className={"btn btn-primary btn_loader mb-3 " + (this.state.submitting ? "loading" : "")} 
                                                        onClick={()=>this.handleConfirm()} 
                                                        type="button" 
                                                        disabled={!this.isValid() || this.state.submitting}>
                                                        Pay &amp; Confirm
                                                    </button>
                                                </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="modalform">
                    <EditBookingTimeForm 
                        isOpen={this.state.modalChangeTime}
                        startDate={pricingModel.breakdown[0].startTime}
                        locationId={selectedLocationId}
                        untilDate={pricingModel.breakdown[0].endTime}
                        isFetching={isFetching}
                        toggle={()=>this.toggle("modalChangeTime")} /> 
                    <UserLoginForm isOpen={this.state.modalLogin}
                        toggle={()=>this.toggle("modalLogin")}
                        loggingIn={loggingIn} />
                    <EditSpecialDealDetailForm isOpen={this.state.modalDealDeails} 
                        toggle={()=>this.toggle("modalDealDeails")}
                        onSubmit={this.handleSpecialDealSubmit}/>
                    <AddVehicleModalForm onSubmit={this.addVehicle}
                        attemptedFind={this.props.accountDetail.addVehicleModal.attemptedFind}
                        isLoading={this.props.accountDetail.addVehicleModal.isFindingVehicle}
                        isOpen={this.state.modalVehicleDetails}

                        // sending checkVehicleReg as function 
                        // props reserved
                        findVehicle={(reg) => this.props.vehicleActions.checkVehicleReg(reg)}
                        toggle={() => this.toggle("modalVehicleDetails")} />
                    
                    </div>
                </div>
            </div>

        );

    }
}

PayAndConfirmPage.propTypes={
    homeActions:PropTypes.object,
    history:PropTypes.object,
    locationDetail:PropTypes.object.isRequired,
    accountDetail:PropTypes.object,
    authentication:PropTypes.object,
    pricing:PropTypes.object.isRequired,
    userActions: PropTypes.object.isRequired,
    pricingActions:PropTypes.object,
    paymentDetail:PropTypes.object,
    paymentActions:PropTypes.object,
    vehicleActions:PropTypes.object

}

function mapStateToProps(state) {
    return {
        locationDetail: state.locationDetail,
        accountDetail:state.accountDetails,
        authentication:state.authentication,
        pricing:state.pricing,
        paymentDetail:state.paymentDetail

    };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
        homeActions: bindActionCreators(homeActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        pricingActions: bindActionCreators(pricingActions, dispatch),
        paymentActions: bindActionCreators(paymentActions, dispatch),
        vehicleActions: bindActionCreators(vehicleActions, dispatch)
    };
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(PayAndConfirmPage);




// WEBPACK FOOTER //
// ./src/containers/PayAndConfirmPage.jsx